import { useState } from 'react';
import { toast } from 'react-hot-toast';

import { buyCarOTPVerify } from '../../../api/services';
import { useBuyRequestData } from '../BuyRequestProvider';

interface IVerifyPhoneProps {
  setStep(step: number): void;
}

const VerifyPhone = ({ setStep }: IVerifyPhoneProps) => {
  const [otp, setOtp] = useState<string>('');
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { phone, setNeedsPhoneVerification } = useBuyRequestData();

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();

        if (!otp) {
          toast.error('لطفا کد تایید ارسال شده به موبایل خود را وارد کنید');
          return;
        }

        setSubmitting(true);
        buyCarOTPVerify({ phone, otp }).then(
          ({ data }) => {
            setSubmitting(false);

            if (data.user_verified) {
              setNeedsPhoneVerification(false);
            }

            setStep(3);
          },
          ({ response }) => {
            setSubmitting(false);
            toast.error(response.data.message);
          },
        );
      }}
      className="relative"
    >
      {submitting && <div className="blockUI" />}

      <label className="block text-center font-bold text-xl text-neutral-900 mb-1">
        کد تایید پیامک شده را وارد نمایید:
      </label>

      <div className="primary-field mb-5">
        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          className="text-center no-icon tracking-widest"
          pattern="[0-9]*"
          inputMode="numeric"
          maxLength={6}
          placeholder="-  -  -  -"
        />
      </div>

      {/* <label className="block text-center font-bold text-xl text-neutral-900 mb-1">توضیحات (اختیاری)</label>

      <div className="primary-field mb-5">
        <textarea
          className="text-center"
          placeholder="اگر توضیحات یا نکات خاصی دارید که بهتر است کارشناس بداند، لطفا در این کادر تایپ نمایید."
        />
      </div> */}

      <div className="flex">
        <button type="button" onClick={() => setStep(1)} className="button cancel primary right block w-1/2">
          بازگشت
        </button>
        <button type="submit" disabled={submitting} className="button primary left block w-1/2">
          تایید شماره
        </button>
      </div>
    </form>
  );
};

export default VerifyPhone;
